var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActive = function SvgActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.071.572 2.357 2.357-7.071 7.07 7.071 7.072-2.357 2.357L10 12.357l-7.071 7.071-2.357-2.357L7.642 10 .573 2.929 2.929.572l7.07 7.07 7.072-7.07Z",
    fill: "#000",
    fillRule: "evenodd"
  })));
};
export default SvgActive;